// extracted by mini-css-extract-plugin
export default {"wrapper":"ImageCarousel_wrapper__Yh5Cx","container":"ImageCarousel_container__OcfZp","inner-container":"ImageCarousel_inner-container__B+6vH"};